/* ==========================================================================
   Customer Gallery — paged slider
   Reads --cards-per-view from CSS (breakpoint-aware).
   Advances one card per click; arrow disabled states reflect edges.
   ========================================================================== */

(function () {
    document.querySelectorAll('.customer-gallery').forEach(init);

    function init(root) {
        var track = root.querySelector('[data-gallery-track]');
        var slides = root.querySelectorAll('[data-gallery-slide]');
        var prevBtn = root.querySelector('[data-gallery-prev]');
        var nextBtn = root.querySelector('[data-gallery-next]');

        if (!track || !slides.length || !prevBtn || !nextBtn) return;

        var total = slides.length;
        var index = 0;

        function cardsPerView() {
            var raw = getComputedStyle(root).getPropertyValue('--cards-per-view');
            var parsed = parseFloat(raw);
            return isNaN(parsed) || parsed <= 0 ? 1 : parsed;
        }

        function maxIndex() {
            return Math.max(0, Math.ceil(total - cardsPerView()));
        }

        function update() {
            var cpv = cardsPerView();
            var slideWidth = 100 / cpv;
            var maxTranslate = Math.max(0, (total - cpv) * slideWidth);
            var target = Math.min(index * slideWidth, maxTranslate);

            track.style.transform = 'translateX(-' + target + '%)';

            prevBtn.disabled = index <= 0;
            nextBtn.disabled = index >= maxIndex();
        }

        prevBtn.addEventListener('click', function () {
            if (index <= 0) return;
            index -= 1;
            update();
        });

        nextBtn.addEventListener('click', function () {
            if (index >= maxIndex()) return;
            index += 1;
            update();
        });

        // Re-clamp index on resize so a desktop-end position doesn't break on tablet.
        var resizeFrame;
        window.addEventListener('resize', function () {
            if (resizeFrame) cancelAnimationFrame(resizeFrame);
            resizeFrame = requestAnimationFrame(function () {
                index = Math.min(index, maxIndex());
                update();
            });
        });

        update();
    }
})();
